document.addEventListener('DOMContentLoaded', function() {
    function updatePriceDisplay() {
        // Get the selected variant input
        const selectedInput = document.querySelector('input[name="Stock Up and Save-1"]:checked');
        if (!selectedInput) return;
        
        // Get the corresponding label
        const selectedLabel = selectedInput.nextElementSibling;
        if (!selectedLabel) return;
        
        // Get the base price from the first variant (1-variant-price)
        const firstVariantLabel = document.querySelector('[\\31 -variant-price]');
        let basePrice = 0;
        if (firstVariantLabel) {
            const basePriceStr = firstVariantLabel.getAttribute('1-variant-price');
            basePrice = parseFloat(basePriceStr.replace('$', ''));
        }
        
        // Get quantity from selected variant
        const quantityStr = selectedLabel.getAttribute('variant-option-product-count-muz');
        let quantity = 1;
        
        if (quantityStr && quantityStr.toLowerCase() !== 'single') {
            quantity = parseInt(quantityStr) || 1;
        }
        
        // Get actual variant price from the selected label's attribute
        let actualVariantPrice = 0;
        const variantPriceAttr = selectedLabel.getAttribute(quantity + '-variant-price');
        if (variantPriceAttr) {
            actualVariantPrice = parseFloat(variantPriceAttr.replace('$', ''));
        }
        
        // Calculate prices
        const calculatedTotalPrice = basePrice * quantity;
        const actualTotalPrice = actualVariantPrice * quantity;
        
        // Get price display elements
        const priceContainer = document.querySelector('.price__container');
        const regularPriceDiv = document.querySelector('.price__regular');
        const regularPriceSpan = document.querySelector('.price__regular .price-item--regular');
        const savingsBadge = document.querySelector('.price__badge-sale');
        
        // Remove any existing comparison price
        const existingComparison = priceContainer?.querySelector('.price-comparison-muzamil');
        if (existingComparison) {
            existingComparison.remove();
        }
        
        console.log('Base Price:', basePrice);
        console.log('Quantity:', quantity);
        console.log('Calculated Total:', calculatedTotalPrice);
        console.log('Actual Total:', actualTotalPrice);
        
        // Show comparison if there are savings
        if (calculatedTotalPrice > actualTotalPrice && quantity > 1) {
            // Keep regular price visible and update it
            if (regularPriceSpan) {
                regularPriceSpan.textContent = '$' + actualTotalPrice.toFixed(2);
            }
            
            // Create and add comparison price element
            const comparisonElement = document.createElement('div');
            comparisonElement.className = 'price-comparison-muzamil';
            comparisonElement.innerHTML = `
                <span style="text-decoration: line-through; color: #999; margin-left: 10px; font-size: 0.9em;">
                    $${calculatedTotalPrice.toFixed(2)}
                </span>
            `;
            
            // Add it after the regular price
            if (regularPriceDiv) {
                regularPriceDiv.appendChild(comparisonElement);
            }
            
            // Update savings badge
            const savingsPercentage = Math.round(((calculatedTotalPrice - actualTotalPrice) / calculatedTotalPrice) * 100);
            if (savingsBadge) {
                savingsBadge.textContent = savingsPercentage + '% OFF';
                savingsBadge.style.display = 'inline-block';
            }
        } else {
            // Show regular price only
            if (regularPriceSpan) {
                regularPriceSpan.textContent = '$' + actualTotalPrice.toFixed(2);
            }
            if (savingsBadge) {
                savingsBadge.style.display = 'none';
            }
        }
        
        // Make sure regular price is visible and sale price is hidden
        if (regularPriceDiv) regularPriceDiv.style.display = 'block';
        const salePriceDiv = document.querySelector('.price__sale');
        if (salePriceDiv) salePriceDiv.style.display = 'none';
    }
    
    // Run on page load
    updatePriceDisplay();
    
    // Add event listeners to all variant radio buttons
    const variantInputs = document.querySelectorAll('input[name="Stock Up and Save-1"]');
    variantInputs.forEach(input => {
        input.addEventListener('change', updatePriceDisplay);
    });
});